export default __webpack_public_path__ + "static/media/aigerim.6a57b873.jpeg";